import { render, staticRenderFns } from "./TrainingNew.vue?vue&type=template&id=6f66b558"
import script from "./TrainingNew.vue?vue&type=script&lang=js"
export * from "./TrainingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports